ui.defaultTheme = {
	button: {
		button: "m-button-button",
		disabled: "m-button-disabled",
		hover: "m-hover",
		img: "m-button-img",
		icon: "m-button-icon",
		selected: "m-selected",
		self: "m-button-self",
		pressed: "m-pressed",
	},
	buttonGroup: {
		button: {
			button: "m-button-group-button",
			img: "m-button-group-img",
		},
		self: "m-button-group-self",
	},
	buttonSVG: {
		button: "m-buttonsvg-button",
		disabled: "m-buttonsvg-disabled",
		hover: "m-hover",
		img: "m-buttonsvg-img",
		selected: "m-selected",
		self: "m-buttonsvg-self",
	},
	calendar: {
		body: "m-calendar-body",
		bodyContent: "m-calendar-body-content",
		bodyHeader: "m-calendar-body-header",
		currentDate: "m-current-date",
		datesButtonGroup: {
			button: {
				button: "m-dates-button-group-button",
				disabled: "m-dates-button-group-button-disabled",
			},
			self: "m-dates-button-group",
		},
		datesHeader: {
			tileItem: "m-dates-header-day",
			tiles: "m-dates-header-parent",
		},
		decadesButtonGroup: {
			button: {
				button: "m-decades-button-group-button",
				disabled: "m-decades-button-group-button-disabled",
			},
			self: "m-decades-button-group",
		},
		footerButton: {
			button: "m-calendar-footer-button",
			disabled: "m-calendar-footer-button-disabled",
		},
		headerButtonGroup: {
			self: "m-calendar-header-button-group",
		},
		monthsButtonGroup: {
			button: {
				button: "m-months-button-group-button",
				disabled: "m-months-button-group-button-disabled",
			},
			self: "m-months-button-group",
		},
		otherCentury: "m-other-century",
		otherDecade: "m-other-decade",
		otherMonth: "m-other-month",
		self: "m-calendar-self",
		yearsButtonGroup: {
			button: {
				button: "m-years-button-group-button",
				disabled: "m-years-button-group-button-disabled",
			},
			self: "m-years-button-group",
		},
	},
	card: {
		body: "m-card-body",
	},
	checkboxRadio: {
		radioParent: "m-checkbox-radio-parent",
		radioText: "m-checkbox-radio-text-span",
		checkbox: {
			input: "m-checkbox-input",
			span: "m-checkbox-span",
		},
		radio: {
			input: "m-radio-input",
			span: "m-radio-span",
		},
		disabled: "m-checkbox-radio-disabled",
	},
	checkbox: {
		container: "m-checkbox-container",
		text: "m-checkbox-text-span",
		input: "m-checkbox-input",
		span: "m-checkbox-span",
		disabled: "m-checkbox-disabled",
		self: "m-checkbox-self",
	},
	checkboxGroup: {
		checkbox: {
			input: "m-checkbox-group-input",
			span: "m-checkbox-group-span",
			label: "m-checkbox-group-label",
		},
		self: "m-checkbox-group-self",
	},
	combobox: {
		buttonGroup: {
			button: {
				button: "m-combobox-button-group-button",
			},
			self: "m-combobox-button-group",
		},
		dropdown: {
			button: {
				button: "m-combobox-button",
			},
			container: "m-combobox-dropdown-container",
			self: "m-combobox-dropdown-parent",
		},
		container: "m-combobox-container",
		wrapper: "m-dropdown-wrapper",
		input: {
			input: "m-combobox-input-input",
			inputWrapper: "m-combobox-input-wrapper",
		},
		self: "m-combobox-self",
	},
	datePicker: {
		calendar: {
			body: "m-date-picker-calendar-body",
			bodyContent: "m-date-picker-calendar-body-content",
			bodyHeader: "m-date-picker-calendar-body-header",
			headerButtonGroup: {
				self: "m-date-picker-calendar-header",
			},
			self: "m-date-picker-calendar-parent",
		},
		dropdown: {
			button: {
				button: "m-date-picker-button fa-regular fa-calendar-days",
			},
			container: "m-date-picker-dropdown-container",
			self: "m-date-picker-dropdown-parent",
		},
		dropdownWrapper: "m-date-picker-dropdown-wrapper",
		input: {
			self: "m-date-picker-input-self",
			input: "m-date-picker-input-input",
			container: "m-date-picker-input-container",
		},
		self: "m-date-picker-self",
	},
	dialog: {
		container: "m-dialog-container",
		body: "m-dialog-body",
		button: {
			button: "m-dialog-button fa-solid fa-xmark",
		},
		buttonLeft: {
			button: "m-dialog-button fa-solid fa-xmark left",
		},
		header: "m-dialog-header",
		headerCenter: "m-dialog-header-center",
		headerLeft: "m-dialog-header-left",
		headerRight: "m-dialog-header-right",
		headerTitle: "m-dialog-header-title",
		footer: "m-dialog-footer",
		self: "m-dialog-self",
	},
	dragDrop: {
		dropText: "m-drag-drop-text",
		dropIcon: "m-drag-drop-icon fa-regular fa-file",
		self: "m-drag-drop-self",
	},
	draggable: {
		draggable: "m-draggable",
		self: "m-draggable-self",
	},
	dropdown: {
		button: {
			button: "m-dropdown-button",
			self: "m-dropdown-button-self",
		},
		container: "m-dropdown-container",
		open: "m-open",
		self: "m-dropdown-self",
	},
	fileChooser: {
		button: {
			button: "m-file-chooser-button",
			self: "m-file-chooser-button-self",
		},
		input: {
			input: "m-file-chooser-input",
			label: "m-file-chooser-label",
			self: "m-file-chooser-input-self",
		},
		self: "m-file-chooser-self",
		wrapper: "m-file-chooser-input-wrapper",
	},
	grid: {
		body: "m-grid-body",
		button: "m-grid-button",
		calendarParent: "m-grid-calendar-parent",
		cell: "m-grid-cell",
		colCell: "m-grid-col-cell",
		comboboxDropDownContainer: "m-grid-combobox-dropdown-container",
		comboboxParent: "m-grid-combobox-parent",
		datePickerParent: "m-grid-date-picker-parent",
		dropDownContainer: "m-grid-dropdown-container",
		dropDownParent: "m-grid-dropdown-parent",
		dropImgDropIcon: "m-grid-drag-drop-icon",
		dropParent: "m-grid-drag-drop-parent",
		dropText: "m-grid-drag-drop-text",
		grid: "m-grid",
		header: "m-grid-hdr",
		headerTitle: "m-grid-title",
		input: "m-grid-input",
		inputContainer: "m-grid-input-container",
		row: "m-grid-row",
		self: "m-grid-self",
		text: "m-grid-text",
		tileItem: "m-tile-item",
		tiles: "m-tiles",
		timePickerDropDownContainer: "m-grid-time-picker-dropdown-container",
		timePickerParent: "m-grid-time-picker-parent",
		treeViewParent: "m-grid-tree-view-parent",
	},
	input: {
		container: "m-input-container",
		clearButton: {
			button: "m-input-button fa-solid fa-xmark",
		},
		leftButton: {
			button: "m-input-button fa-solid fa-eye-slash",
		},
		input: "m-input-input",
		label: "m-input-label",
		self: "m-input-self",
		icon: "m-input-icon",
		errorIcon: "m-input-error-icon fa-solid fa-exclamation-triangle hidden",
		successIcon: "m-input-success-icon fa-solid fa-check hidden",
		errorText: "m-input-error-text hidden",
	},
	listbox: {
		container: "m-listbox-container",
		item: "m-listbox-item",
		self: "m-listbox-self",
	},
	listMenu: {
		self: "m-list-menu-self",
		container: "m-list-menu-container",
		wrapper: "m-list-menu-wrapper",
		body: "m-list-menu-body",
		title: "m-list-menu-title",
		subtitle: "m-list-menu-subtitle",
		icon: "m-list-menu-icon",
	},
	mapbox: {
		container: "m-mapbox-container",
		currentPoint: "m-mapbox-current-point",
		hidewait: "m-mapbox-hide-wait",
		self: "m-mapbox-self",
	},
	pagination: {
		self: "m-pagination-self",
		container: "m-pagination-container",
	},
	percentage: {
		bar: "m-percentage-bar",
		self: "m-percentage-self",
		text: "m-percentage-text",
	},
	player: {
		player: "m-player-player",
		self: "m-player-self",
	},
	radio: {
		container: "m-radio-container",
		text: "m-radio-text",
		input: "m-radio-input",
		span: "m-radio-span",
		disabled: "m-radio-disabled",
		self: "m-radio-self",
	},
	radioGroup: {
		radio: {
			input: "m-radio-group-input",
			span: "m-radio-group-span",
			label: "m-radio-group-label",
		},
		self: "m-radio-group-self",
	},
	rating: {
		disabled: "m-rating-disabled",
		empty: "m-rating-empty",
		emptyStar: "m-rating-empty-star",
		hover: "m-rating-hover",
		hoverStar: "m-rating-hover-star",
		selected: "m-rating-selected",
		selectedStar: "m-rating-selected-star",
		self: "m-rating-self",
	},
	search: {
		dropdown: {
			button: {
				button: "m-search-button fa-solid fa-magnifying-glass",
			},
			container: "m-search-dropdown-container",
			self: "m-search-dropdown-parent",
		},
		input: {
			input: "m-search-input-input",
			inputWrapper: "m-search-input-wrapper",
		},
		inputContainer: "m-search-input-container",
		listbox: {
			item: "m-search-listbox-item",
		},
		searchButton: {
			button: "m-search-button fa-solid fa-magnifying-glass",
		},
		self: "m-search-self",
		wrapper: "m-search-dropdown-wrapper",
	},
	slideout: {
		body: "m-slideout-body",
		header: "m-slideout-header",
		open: "m-open",
		openAnimation: "m-fade-in",
		overlay: "m-slideout-overlay",
		self: "m-slideout-self",
		button: { button: "m-slideout-close-button fa-solid fa-xmark" },
	},
	slider: {
		disabled: "m-slider-disabled",
		horizontal: {
			decreaseButton: {
				button: "m-slider-button-decrease-horizontal fa-solid fa-caret-left",
			},
			handle: "m-slider-handle-horizontal",
			increaseButton: {
				button: "m-slider-button-increase-horizontal fa-solid fa-caret-right",
			},
			self: "m-slider-parent-horizontal",
			selection: "m-slider-selection-horizontal",
			step: "m-slider-step-horizontal",
			stepLarge: "m-slider-step-large-horizontal",
			stepLargeSpan: "m-slider-step-large-span-horizontal",
			stepsContainer: "m-slider-steps-container-horizontal",
			track: "m-slider-track-horizontal",
			wrapper: "m-slider-wrapper-horizontal",
		},
		self: "m-slider-self",
		vertical: {
			decreaseButton: {
				button: "m-slider-button-decrease-vertical fa-solid fa-caret-down",
			},
			handle: "m-slider-handle-vertical",
			increaseButton: {
				button: "m-slider-button-increase-vertical fa-solid fa-caret-up",
			},
			self: "m-slider-parent-vertical",
			selection: "m-slider-selection-vertical",
			step: "m-slider-step-vertical",
			stepLarge: "m-slider-step-large-vertical",
			stepLargeSpan: "m-slider-step-large-span-vertical",
			stepsContainer: "m-slider-steps-container-vertical",
			track: "m-slider-track-vertical",
			wrapper: "m-slider-wrapper-vertical",
		},
	},
	switch: {
		container: "m-switch-container",
		disabled: "m-switch-disabled",
		handle: "m-switch-handle",
		input: "m-switch-input",
		off: "m-switch-label-off",
		on: "m-switch-label-on",
		text: "m-switch-text",
		self: "m-switch-self",
	},
	tab: {
		body: "m-tab-body",
		content: "m-tab-content",
		selectedTab: "m-selected",
		self: "m-tab-self",
		tabs: "m-tabs",
	},
	textarea: {
		cancelButton: {
			button: "m-input-button fa-solid fa-xmark cancel-btn",
		},
		editButton: {
			button: "m-input-button fa-solid fa-edit edit-btn",
		},
		checkButton: {
			button: "m-input-button fa-solid fa-check check-btn",
		},
		buttonsContainer: "m-textarea-buttons-container",
		containerDown: "m-textarea-container-down",
		containerUp: "m-textarea-container-up",
		footer: "m-textarea-footer",
		iconsContainer: "m-textarea-icons-container",
		iconRequired: "m-textarea-icon-required fa-solid fa-exclamation-triangle hidden",
		label: "m-textarea-label",
		span: "m-textarea-span",
		self: "m-textarea-self",
		textarea: "m-textarea-textarea",
		textRequired: "m-textarea-text-required hidden",
	},
	timePicker: {
		combobox: {
			dropdown: {
				button: {
					button: "m-time-picker-combobox-button fa-regular fa-clock",
				},
				container: "m-time-picker-dropdown-container",
			},
			self: "m-time-picker-combobox",
		},
		self: "m-time-picker-self",
	},
	toaster: {
		body: "m-toaster-body",
		iconContainer: "m-toaster-icon-container",
		buttonContainer: "m-toaster-button-container",
		button: {
			button: "m-toaster-button fa-solid fa-xmark",
		},
		self: "m-toaster-self",
		icon: {
			success: "fa-solid fa-check-circle",
			warning: "fa-solid fa-exclamation-triangle",
			error: "fa-solid fa-exclamation-triangle",
			info: "fa-solid fa-info-circle",
		},
		size: {
			small: "m-toaster-small",
			medium: "m-toaster-medium",
			large: "m-toaster-large",
		},
		type: {
			error: "m-toaster-error",
			info: "m-toaster-info",
			success: "m-toaster-success",
			warning: "m-toaster-warning",
		},
		position: {
			left: "m-toaster-left",
			center: "m-toaster-center",
			centerV: "m-toaster-center-v",
			right: "m-toaster-right",
			top: "m-toaster-top",
			bottom: "m-toaster-bottom",
		},
		animation: {
			topBottomIn: "m-toaster-slide-in-top",
			bottomTopIn: "m-toaster-slide-in-bottom",
			topBottomOut: "m-toaster-slide-out-top",
			bottomTopOut: "m-toaster-slide-out-bottom",
		},
	},
	tooltip: {
		body: "m-tooltip-body",
		self: "m-tooltip-self",
		open: "m-tooltip-open",
	},
	treeView: {
		expanded: "m-expanded",
		group: "m-tree-view-group",
		hover: "m-hover",
		icon: "m-tree-view-item-icon fa-solid",
		iconCollapse: "fa-caret-down",
		iconExpand: "fa-caret-right",
		in: "m-tree-view-item-in",
		item: "m-tree-view-item",
		selected: "m-selected",
		self: "m-tree-view-self",
		itemTop: "m-tree-view-item-top",
	},
	videoPlayer: {
		self: "m-video-player-self",
	},
};

ui.class.Theme = class Theme {
	constructor() {
		this.m_themes = {
			default: ui.defaultTheme,
		};

		this.linkClass = "mambo-stylesheet";
	}

	loadStylesheets(context) {
		return new Promise((resolve) => {
			context?.stylesheets?.forEach((href) => {
				const link = document.createElement("link");
				link.rel = "stylesheet";
				link.href = href;
				link.className = context.linkClass || this.linkClass;
				document.head.appendChild(link);
			});

			resolve();
		});
	}

	async reloadStylesheets(context) {
		const links = document.querySelectorAll(`link.${context.linkClass || this.linkClass}`);
		await this.loadStylesheets(context);

		setTimeout(() => {
			if (links?.length > 0) {
				links.forEach((link) => link.remove());
			}
		}, 100);
	}

	getTheme(context) {
		if (context && context.name && context.component) {
			if (context.name in this.m_themes) {
				return this.m_themes[context.name][context.component];
			}
		}
	}

	addTheme(context) {
		if (!context || !context.name || !context.theme) {
			throw "Theme: you invoked addTheme() but failed to define the theme name and/or theme.";
		}

		if (this.m_themes[context.name] && !this.m_themes[context.override]) {
			throw `Theme: you have attempted to override the theme name ${context.name}. Please add the property 'override:true' to succesfully override the theme.`;
		}

		this.m_themes[context.name] = context.theme;
	}
};

// Initialize theme with config
ui.theme = new ui.class.Theme();
